import { useContent } from '../../../hooks/use-server-content';
import { MEDIA_TYPE } from '@own/fds-react/dist/types/cards.types';

export interface DyfFdsCardProps {
    title: string;
    subtitle?: string;
    body?: string;
    mediaType: MEDIA_TYPE;
    mediaWidth?: string;
    mediaSrc: string;
    mediaAltText?: string;
    mediaHref?: string;
    alertType?: string;
    alertText?: string;
    horizontal?: boolean;
    reverse?: boolean;
}

export const useDyfFdsCardContent = (
    name: 'htv' | 'livestream' | 'gvt'
): DyfFdsCardProps => {
    const [content, getValueByName] = useContent(
        'dyf/feature-guide',
        `dyf-landing-${name}-card`
    );
    const contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    return contentFragment as DyfFdsCardProps;
};
